import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import Color from "../../../assets/colors";
import { FontSize } from "../../../assets/font";

// =============== GRID COMPONENTS =============== //

export const ContainerStyled = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
}));

export const BreadcrumbContainer = styled(Grid)(({ theme }) => ({
  marginBottom: "30px",
}));

// =============== TYPOGRAPHY COMPONENTS =============== //

export const TitleStyled = styled(Typography)((props) => ({
  fontWeight: FontSize.bold,
  fontSize: FontSize.desktopBody,
  marginBottom: "20px",

  // [props.theme.breakpoints.down("sm")]: {
  //   fontSize: FontSize.mobileBody,
  // },
}));

export const BreadcrumbStyled = styled(Typography)(({ theme }) => ({
  fontSize: FontSize.desktopCaption,
  color: Color.black,
}));

// =============== LINK COMPONENTS =============== //

export const MaterialUiLinkStyled = styled(Link)(({ $current_page }) => ({
  color: $current_page ? Color.hiredlyPurple : Color.black,
  fontSize: FontSize.desktopCaption,
  fontWeight: $current_page ? FontSize.bold : "normal",
  margin: "0 30px 25px 0",
  textDecoration: "none",
  transition: "color 0.2s ease",

  "&:hover": {
    textDecoration: "none",
    color: Color.hiredlyPurple,
  },
}));

export const BreadcrumbLinkStyled = styled(Link)(({ theme }) => ({
  color: Color.darkGrey,
  fontSize: FontSize.desktopCaption,
  textDecoration: "none",
  transition: "color 0.2s ease",

  "&:hover": {
    textDecoration: "none",
    color: Color.hiredlyPurple,
  },
}));
